// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_jq","advertCardPhoto__image":"c-a_jr"};